import React, { Component } from "react";
import { getAuth, signOut } from "firebase/auth";
import { Link } from "react-router-dom";
import logo from "../../static/ibtehaz_white.png";
import logo_dark from "../../static/ibtehaz_dark.png";
import themeLarge from "../ThemeLarge";
import withRouter from "../withRouter";

class DesktopNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
      isHome: true, // Track if current page is home
    };
  }

  componentDidMount() {
    const auth = getAuth();
    auth.onAuthStateChanged((user) => {
      this.setState({ isAuthenticated: !!user });
    });

    this.updateNavState(this.props.router.location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.router.location.pathname !== this.props.router.location.pathname
    ) {
      this.updateNavState(this.props.router.location.pathname);
    }
  }

  updateNavState = (pathname) => {
    const isHome = pathname === "/";
    this.setState({ isHome });
  };

  handleLogout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        this.setState({ isAuthenticated: false });
      })
      .catch((error) => {});
  };

  render() {
    const { isAuthenticated, isHome } = this.state;

    const backgroundColor = isHome
      ? themeLarge.colors.secondary
      : themeLarge.colors.primary;

    const textColor = isHome ? themeLarge.colors.text : "#ffffff";
    const logoSrc = isHome ? logo_dark : logo;

    return (
      <nav
        className="navbar navbar-expand-lg"
        style={{
          position: "fixed", // 🔒 Stick to top
          top: 0,
          left: 0,
          right: 0,
          width: "100%", // Full width
          paddingLeft: "30px",
          paddingRight: "30px",
          height: "75px",
          background: backgroundColor,
          transition: "background-color 0.6s ease-in-out",
          boxShadow: themeLarge.shadows.standard,
          zIndex: 1030, // On top of most content
        }}
      >
        <Link className="navbar-brand" to="/">
          <img
            src={logoSrc}
            width="200px"
            className="d-inline-block align-top"
            alt="Logo"
            style={{ transition: "all 0.5s ease-in-out" }}
          />
        </Link>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNavAltMarkup"
          style={{
            fontSize: themeLarge.fontSize.h4,
            fontFamily: "Kumbh Sans",
            color: textColor,
          }}
        >
          <div className="navbar-nav">
            <Link
              className="nav-item nav-link"
              to="/"
              style={this.linkStyle(textColor)}
            >
              Home
            </Link>
            <Link
              className="nav-item nav-link"
              to="/origin"
              style={this.linkStyle(textColor)}
            >
              Origin Story
            </Link>
            <Link
              className="nav-item nav-link"
              to="/projects"
              style={this.linkStyle(textColor)}
            >
              Projects
            </Link>
            <Link
              className="nav-item nav-link"
              to="/blogs"
              style={this.linkStyle(textColor)}
            >
              Blogs
            </Link>
            {/* <Link
              className="nav-item nav-link"
              to="/"
              style={this.linkStyle(textColor)}
            >
              Get in Touch
            </Link> */}

            <a
              className="nav-item nav-link"
              href="https://www.linkedin.com/in/ibtehaz/"
              target="_blank"
              rel="noopener noreferrer"
              style={this.linkStyle(textColor)}
            >
              Get in Touch
            </a>

            {isAuthenticated && (
              <>
                <Link
                  className="nav-item nav-link"
                  to="/dashboard"
                  style={this.linkStyle(textColor)}
                >
                  Dashboard
                </Link>
                <a
                  className="nav-item nav-link"
                  href="#logout"
                  onClick={this.handleLogout}
                  style={this.linkStyle(textColor)}
                >
                  Logout
                </a>
              </>
            )}
          </div>
        </div>
      </nav>
    );
  }

  linkStyle(color) {
    return {
      color: color,
      textShadow: themeLarge.shadows.textShadow,
      transition: "color 0.5s ease-in-out",
    };
  }
}

export default withRouter(DesktopNavigation);
